import * as React from "react";
import { toTitleCase, sortItems } from "./Functions";
import ListContent from "./ListContent";
import { FontIcon } from "@fluentui/react";
import { IItem } from "../../models/IItem";

interface IProps {
  eid: string;
  items: IItem[];
  heading: string;
  sort?: string;
  sortdesc?: string;
  target?: string;
  ButtonsAndFunctions?: {
    Name: string;
    ColumnKey: string;
    Function: (id: any) => void;
  }[];
}

interface IState {
  items: IItem[];
}

class AccordionContent extends React.Component<IProps, IState> {
  private static instanceCount = 0;

  // react-accessible-accordion has been abandoned - now using HTML Disclose controls.
  private readonly groupName = `UoE-DataAccordion-${AccordionContent.instanceCount++}`;

  constructor(props) {
    super(props);
    this.state = {
      items: sortItems(this.props.items, this.props.sort, this.props.sortdesc),
    };
  }

  public render() {
    return (
      <div className={"UoE-DataAccordion"}>
        {this.state.items.map((item, ii) => (
          <details
            key={ii}
            name={this.groupName}
            className={"DataAccordion".concat(
              item[this.props.heading + "_CSS"] !== undefined &&
                item[this.props.heading + "_CSS"].trim() !== ""
                ? " " + item[this.props.heading + "_CSS"]
                : "",
              item[this.props.heading + "_CLASS"] !== undefined &&
                item[this.props.heading + "_CLASS"].trim() !== ""
                ? " " + item[this.props.heading + "_CLASS"]
                : "",
            )}
          >
            <summary className="accordion__heading accordion__button">
              <FontIcon iconName="ScrollUpDown" />
              <em
                dangerouslySetInnerHTML={{
                  __html:
                    toTitleCase(this.props.heading.replace(/_/g, " ").trim()) +
                    ":",
                }}
              />
              <span
                className="column-value"
                dangerouslySetInnerHTML={{ __html: item[this.props.heading] }}
              />
            </summary>
            <div className="accordion__panel">
              <ListContent
                eid={this.props.eid}
                items={[item]}
                target={this.props.target}
                ButtonsAndFunctions={this.props.ButtonsAndFunctions}
              />
            </div>
          </details>
        ))}
      </div>
    );
  }
}

export default AccordionContent;
